export interface IConfigDeductionSlaConfig {
  id: number;
  configKey: string;
  configValue: number;
  description: string | null;
}

export class ConfigDeductionSlaConfig {
  private readonly _id: number;
  private readonly _configKey: string;
  private readonly _configValue: number;
  private readonly _description: string | null;

  constructor(props: IConfigDeductionSlaConfig) {
    this._id = props.id;
    this._configKey = props.configKey;
    this._configValue = props.configValue;
    this._description = props.description;
  }

  get id(): number {
    return this._id;
  }
  get configKey(): string {
    return this._configKey;
  }
  get configValue(): number {
    return this._configValue;
  }
  get description(): string | null {
    return this._description;
  }

  static from(props: IConfigDeductionSlaConfig): ConfigDeductionSlaConfig {
    return new ConfigDeductionSlaConfig(props);
  }

  static toJSON(entity: ConfigDeductionSlaConfig): IConfigDeductionSlaConfig {
    return {
      id: entity.id,
      configKey: entity.configKey,
      configValue: entity.configValue,
      description: entity.description,
    };
  }
}
